// src/i18n/simple-i18n.js
// 完全自定义的 i18n 实现，不依赖 vue-i18n

const translations = {
  'en-US': {
    'session.chat.transfer.failed': 'Unable to transfer to an agent. Please try again.',
    'session.chat.time': '{year}/{month}/{day}',
    'session.chat.viewHistory': 'View history messages',
    'session.chat.currentSessionMessages': 'Current session messages',
    'session.chat.button.placeholder': 'Please input ...',
    'session.chat.button.lineBreak': 'Press Shift+Enter to line break',
    'common.send': 'Send',
    'common.close': 'Close',
    'setting.channel.defaultWeb': 'Default Web',
    'customer.chat.allLoad': 'all chats loaded',
    'session.chat.comment': 'Comment',
    'session.chat.image': 'Image',
    'session.chat.file': 'Attach',
    'session.chat.more': 'More actions',
    'session.chat.emoji': 'Emoji',
    'session.chat.comment.placholder': 'Please leave your comment~',
    'session.chat.comment.zero': 'Please Comment~',
    'session.chat.comment.appr': 'Thank you～',
    'session.chat.comment.failed': 'Failed to submit comment. Please try again.',
    'session.announcement.title': 'Announcement',
    'session.warn': 'Sensitive words detected, please mind your behavior',
    'session.block':
      'Session content contains serious sensitive words, the other party will not receive it',
    'session.rechat.button': 'New Chat',
    'session.rechat.desc': 'Session ended, you can start a new chat',
    'session.email.placeholder': '[EMAIL] has sent to ',
    'widget.error.domainUnauthorized': 'This domain is not accessible',
    'widget.agent.authError.title': 'Session expired',
    'widget.agent.authError.desc': 'Please reopen the link from the source.',
    'widget.agent.offline.desc': 'You are offline and cannot handle live chats.',
    'session.chat.matchQuestion.title': 'This problem may have multiple answers:',
    'session.chat.solved': 'Solved',
    'session.chat.unsolved': 'Mark as solved',
  },
  'zh-CN': {
    'session.chat.transfer.failed': '转人工失败，请重试',
    'session.chat.time': '{year}/{month}/{day}',
    'session.chat.viewHistory': '点击查看历史消息',
    'session.chat.currentSessionMessages': '本次会话消息',
    'session.chat.button.placeholder': '请输入消息...',
    'session.chat.button.lineBreak': '按Shift+Enter换行',
    'common.send': '发送',
    'common.close': '关闭',
    'setting.channel.defaultWeb': '默认网页渠道',
    'customer.chat.allLoad': '全部会话加载完毕',
    'session.chat.comment': '评价',
    'session.chat.image': '图片',
    'session.chat.file': '附件',
    'session.chat.more': '更多操作',
    'session.chat.emoji': '表情',
    'session.chat.comment.placholder': '请输入您的评价～',
    'session.chat.comment.zero': '请评价～',
    'session.chat.comment.appr': '感谢评价～',
    'session.chat.comment.failed': '评价提交失败，请重试',
    'session.announcement.title': '公告',
    'session.warn': '识别到敏感词，请注意规范会话行为',
    'session.block': '会话内容包含严重敏感词，对方无法收到',
    'session.rechat.button': '重新会话',
    'session.rechat.desc': '会话结束，您可重新发起会话',
    'session.email.placeholder': '【邮件】已发送至',
    'widget.error.domainUnauthorized': '该域名无法访问',
    'widget.agent.authError.title': '会话已结束',
    'widget.agent.authError.desc': '请从来源重新打开链接',
    'widget.agent.offline.desc': '您已离线，无法处理在线业务',
    'session.chat.matchQuestion.title': '该问题可能有多个回答：',
    'session.chat.solved': '已解决',
    'session.chat.unsolved': '标记为已解决',
  },
  'zh-TW': {
    'session.chat.transfer.failed': '轉人工失敗，請重試',
    'session.chat.time': '{year}/{month}/{day}',
    'session.chat.viewHistory': '點擊查看歷史訊息',
    'session.chat.currentSessionMessages': '本次會話訊息',
    'session.chat.button.placeholder': '請輸入消息...',
    'session.chat.button.lineBreak': '按Shift+Enter換行',
    'common.send': '發送',
    'common.close': '關閉',
    'setting.channel.defaultWeb': '默認網頁渠道',
    'customer.chat.allLoad': '全部會話加載完畢',
    'session.chat.comment': '評價',
    'session.chat.image': '圖片',
    'session.chat.file': '附件',
    'session.chat.more': '更多操作',
    'session.chat.emoji': '表情',
    'session.chat.comment.placholder': '請輸入您的評價～',
    'session.chat.comment.zero': '請評價～',
    'session.chat.comment.appr': '感謝評價～',
    'session.chat.comment.failed': '評價提交失敗，請重試',
    'session.announcement.title': '公告',
    'session.warn': '識別到敏感詞，請注意規範會話行為',
    'session.block': '會話內容包含嚴重敏感詞，對方無法收到',
    'session.rechat.button': '重新會話',
    'session.rechat.desc': '會話結束，您可重新發起會話',
    'session.email.placeholder': '【電郵】已發送至',
    'widget.error.domainUnauthorized': '該域名無法存取',
    'widget.agent.authError.title': '會話已結束',
    'widget.agent.authError.desc': '請從來源重新開啟連結',
    'widget.agent.offline.desc': '您已離線，無法處理線上業務',
    'session.chat.matchQuestion.title': '該問題可能有多個回答：',
    'session.chat.solved': '已解決',
    'session.chat.unsolved': '標記為已解決',
  },
}

// 支持的语言列表
const supportedLocales = ['en-US', 'zh-CN', 'zh-TW']

// 浏览器语言到支持语言的映射
const localeMap = {
  en: 'en-US',
  'en-US': 'en-US',
  'en-GB': 'en-US',
  zh: 'zh-CN',
  'zh-CN': 'zh-CN',
  'zh-Hans': 'zh-CN',
  'zh-TW': 'zh-TW',
  'zh-HK': 'zh-TW',
  'zh-MO': 'zh-TW',
}

/**
 * 检测浏览器语言
 * @returns {string} 支持的语言代码
 */
function detectBrowserLanguage() {
  // 获取浏览器语言（优先级：navigator.languages > navigator.language）
  const browserLanguages = [
    ...(navigator.languages || []),
    navigator.language,
    navigator.userLanguage,
  ].filter(Boolean)

  // 尝试匹配支持的语言
  for (const browserLang of browserLanguages) {
    // 精确匹配
    if (supportedLocales.includes(browserLang)) {
      return browserLang
    }

    // 映射匹配（如 'zh' -> 'zh-CN'）
    const mapped = localeMap[browserLang]
    if (mapped && supportedLocales.includes(mapped)) {
      return mapped
    }

    // 前缀匹配（如 'zh-CN' 匹配 'zh'）
    const prefix = browserLang.split('-')[0]
    const matched = supportedLocales.find((locale) => locale.startsWith(prefix))
    if (matched) {
      return matched
    }
  }

  // 默认返回英文
  return 'en-US'
}

/**
 * 从 localStorage 获取保存的语言
 * @returns {string|null}
 */
function getSavedLocale() {
  try {
    return localStorage.getItem('app_locale')
  } catch {
    return null
  }
}

/**
 * 保存语言到 localStorage
 * @param {string} locale
 */
function saveLocale(locale) {
  try {
    localStorage.setItem('app_locale', locale)
  } catch {
    // 忽略存储错误
  }
}

// 初始化语言：优先使用保存的语言，否则检测浏览器语言
let currentLocale = getSavedLocale() || detectBrowserLanguage()

console.log(`🌐 当前语言: ${currentLocale}`)

/**
 * 翻译函数
 * @param {string} key - 翻译键
 * @param {object} params - 参数对象
 * @returns {string}
 */
export const t = (key, params = {}) => {
  const text = translations[currentLocale]?.[key] || translations['en-US'][key] || key
  return Object.entries(params).reduce((result, [k, v]) => {
    return result.replace(new RegExp(`{${k}}`, 'g'), v)
  }, text)
}

/**
 * 设置语言
 * @param {string} locale - 语言代码
 */
export const setLocale = (locale) => {
  if (supportedLocales.includes(locale)) {
    currentLocale = locale
    saveLocale(locale)
    // 触发自定义事件，通知组件语言已更改
    window.dispatchEvent(new CustomEvent('localeChanged', { detail: { locale } }))
  } else {
    console.warn(`Unsupported locale: ${locale}`)
  }
}

/**
 * 获取当前语言
 * @returns {string}
 */
export const getLocale = () => currentLocale

/**
 * 获取支持的语言列表
 * @returns {string[]}
 */
export const getSupportedLocales = () => [...supportedLocales]

/**
 * 获取语言显示名称
 * @param {string} locale
 * @returns {string}
 */
export const getLocaleDisplayName = (locale) => {
  const names = {
    'en-US': 'English',
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
  }
  return names[locale] || locale
}

// Vue 插件
export const i18nPlugin = {
  install(app) {
    // 添加全局属性
    app.config.globalProperties.$t = t
    app.config.globalProperties.$locale = currentLocale

    // 提供全局访问
    app.provide('i18n', {
      t,
      setLocale,
      getLocale,
      locale: { value: currentLocale },
    })

    // 监听语言变化事件，更新组件的语言
    if (typeof window !== 'undefined') {
      window.addEventListener('localeChanged', (event) => {
        app.config.globalProperties.$locale = event.detail.locale
      })
    }
  },
}

// 兼容 useI18n
export const useI18n = () => ({
  t,
  setLocale,
  getLocale,
  locale: { value: currentLocale },
})

export default i18nPlugin
